import { formatCurrencyAmount } from '@opallabs/lambda'
import type { TextFallbackProps } from './types'

const defaultText = 'No money budgeted'
export function textFallback({
  currency = 'USD',
  max,
  value,
}: TextFallbackProps): string {
  if (value == undefined) return defaultText

  const invalidValue = Number.isNaN(value) || value < 0
  if (invalidValue) return defaultText

  return [value, max]
    .map((number) =>
      formatCurrencyAmount({
        currency,
        value: number,
      })
    )
    .join(' of ')
}
